import axios from 'axios'
import store from '@/store'
import storage from 'store'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
const tenantId = storage.get('tenantId')
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  // timeout: 60000 // 请求超时时间
  // 2022年11月24日15:30:26 改为2分钟超时
  timeout: 120000,
  headers: {
    'tenantId': tenantId
  }
})

// 通用响应处理器
const commonHandler = (res) => {
  if (res.config.responseType === 'blob') {
    return res.data
  }
  if (res.data.code === 0 || res.data.info === 'OK') {
    return res.data
  } else {
    if (res.data.message && res.data.message !== '系统繁忙,请稍后再试') {
      notification.warning({
        message: res.data.message,
      })
    }
    return Promise.reject(res)
  }
}

// 异常拦截处理器
const errorHandler = (error) => {
  console.error(error)
  if (error.response) {
    const { status, data } = error.response
    const token = storage.get(ACCESS_TOKEN)

    switch (status) {
      case 403:
        notification.error({ message: '拒绝访问', description: data.message })
        break
      case 404:
        notification.error({ message: '资源不存在', description: '您访问的资源不存在!' })
        break
      case 503:
        notification.warning({ message: '更新中', description: '服务更新中...' })
        break
      case 401:
        if (!(data.result && data.result.isLogin)) {
          notification.warning({ message: '登录过期', description: '登录已过期,请重新登录' })
          if (token) {
            store.dispatch('Logout').then(() => {
              setTimeout(() => window.location.reload(), 1500)
            })
          }
        }
        break
      default:
        break
    }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  const token = storage.get(ACCESS_TOKEN)
  // console.log(config)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token && config.url !== 'https://open.ys7.com/api/lapp/token/get') {
    config.headers[ACCESS_TOKEN] = token
  }
  const tenantId = storage.get('tenantId')
  config.headers['tenantId'] = tenantId

  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use(commonHandler, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
